<template>
<div>
    <div class="columns" style="border: 1px solid #CCC;" v-show="!isEditing">
        <div class="column is-three-quarters">
          <p class="subtitle">
            {{ data.firstName }} {{ data.lastName }}
          </p>
        </div>
        <div class="column is-one-quarter">
          <div class="field has-addons" style="float: right">
            <div class='extra content'>                
              <!-- <span class='right floated edit icon' v-on:click="showQR(data)">
                <font-awesome-icon icon="qrcode" class="icon" />
              </span> -->
              <span class='right floated edit icon' v-on:click="showForm">
                <font-awesome-icon icon="edit" />
              </span>
              <span class='right floated trash icon' v-on:click="deleteData(data)">
                <font-awesome-icon icon="trash-alt" />
              </span>
            </div>
          </div>
        </div>
    </div>
    <div class="columns" style="border: 1px solid #CCC; padding: 10px;" v-show="isEditing">
        <div class="column">            
            <div class="field">
                <label class="label">First Name</label>
                <div class="control">
                    <input class="input" type="text" placeholder="E.g.: Bruce" v-model="data.firstName">
                </div>
            </div>        
            <div class="field">
                <label class="label">Last Name</label>
                <div class="control">
                    <input class="input" type="text" placeholder="E.g.: Bruce" v-model="data.lastName">
                </div>
            </div>        
            <div class="field">
                <label class="label">Staff E-mail</label>
                <div class="control">
                    <input class="input" type="text" placeholder="Staff E-mail" v-model="data.email">
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <b-checkbox v-model="isNewPassword" v-on:change="isEnableNewPassword()">
                        Change Password
                    </b-checkbox>
                </div>
                <div class="control">
                    <input class="input" type="password" placeholder="Password (enter new password to change)" v-model="password1" :disabled="!isNewPassword">
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <input class="input" type="password" placeholder="New password, again" v-model="password2" :disabled="!isNewPassword">
                </div>
            </div>

            <div class="field">
                <label class="label">&nbsp;</label>
                <div class='ui two buttons'>
                    <button class='is-info button' v-on:click="hideForm(data)">OK</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    props: ['data'],
    data() {
        return {
            isEditing: false,            
            password1: '',
            password2: '',
            isNewPassword: false,
            input:{
                email: '',
                _id: '',
                firstName: '',
                lastName: '',
                staffEmail: '',
                isNewPassword: 0,
                newPassword: ''
            }
        };
    },
    methods: {
        isEnableNewPassword(){
            if (isNewPassword){
                this.isNewPassword = true;
            }else{
                this.isNewPassword = false;
            }
        },
        completeData(data) {
            this.$emit('complete-data', data);
        },
        deleteData(data) {
            this.$emit('delete-data', data);
        },
        showForm() {
            this.isEditing = true;
        },
        hideForm(data) {
            //this.$emit('update-data', data);

            if (data.firstName.length > 0 && data.email.length > 0) {

                this.input.email = localStorage.getItem('email')
                this.input._id = data._id
                this.input.firstName = data.firstName
                this.input.lastName = data.lastName
                this.input.staffEmail = data.email
                
                if (this.isNewPassword){
                    if (this.password1.length >=8){                        
                        if (this.password1 == this.password2){
                            this.input.isNewPassword = 1
                            this.input.newPassword = this.password1
                        }else{
                            alert("Please make sure you typed in the correct new password in both fields.")
                            return false;
                        }
                    }else{
                        alert("Password must be at least 8 characters.")
                        return false;
                    }
                }

                //alert("id: " + kelas._id + " name: " + kelas.name)
                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'json'
                axios.post(process.env.MY_URL + '/api/teachers/update', this.input)
                    .then(response => {
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })
                        }
                    })
                    .catch(e => {
                        console.log(e.response)
                        Toast.open({
                            message: e.response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })                        
                    })

            } else {
                alert("Please enter the first name & email");
            }
        
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Staff/DataView.vue